export const ACCESS_USER_TYPE = process.env.REACT_APP_ACCESS_USER_TYPE
export const API_GATEWAY = process.env.REACT_APP_API_GATEWAY
export const API_GATEWAY_STAGING = process.env.REACT_APP_API_GATEWAY_STAGING
export const DEPLOYMENT_REGION = process.env.REACT_APP_DEPLOYMENT_REGION